export const rechargeFormName = 'recharge';

export const genericErrorId = 'error.99999';
export const genericErrorIdRetry = 'err.somethingWentWrong';

export const formErrorKey = 'error-that-applies-to-the-whole-form';

export enum InputFieldUIStates {
  idle,
  error,
  alert,
}
